// URL add parameter
const hisAddSearch = (history, queryObj) => {
  const pushQ = Object.entries(queryObj)
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
  history.push(`?${pushQ}`);
};

export default hisAddSearch;
